module.exports = __webpack_public_path__ + "img/microsoft.874ff92d.svg";